let logoutCallback: (() => void) | null = null;

export const registerLogout = (callback: () => void) => {
  logoutCallback = callback;
};

export const callLogout = () => {
  if (logoutCallback) {
    logoutCallback();
  } else {
    console.warn("Logout callback no está registrado");
  }
};